import React from 'react'
import "./ProfileSettings.css";
import BasicInfo from "./sections/BasicInfo";
import MediaSection from "./sections/MediaSection";
import SportProfile from "./sections/SportProfile";
import StatsSection from "./sections/StatsSection";
import HighlightsSection from "./sections/HighlightsSection";
import PreferencesSection from "./sections/PreferencesSection";
import PrivacySection from "./sections/PrivacySection";
import { useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { get } from '../../http/api';
import PasswordSection from './sections/PasswordSection';
import { useTranslation } from "react-i18next";
import SubscriptionSection from './sections/SubscriptionSection';


const ProfileSettings = () => {

    // const { id_user: profileId } = useParams();
    const profileId = sessionStorage.getItem("id_user")
    const [profile, setProfile] = useState(null);
    const navigate = useNavigate();

    const { t } = useTranslation();


    const fetchProfile = async () => {
        try {
            const res = await get(`users/user/${profileId}`);
            setProfile(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (!profileId) return;
        fetchProfile();
    }, [profileId]);

    return (
        <div className="settings-container">

            <div className="settings-hero">
            <div className="sport-profile-topbar">

                <button
                    className="sport-back-btn"
                    onClick={() => navigate(-1)}
                >
                    <span className="back-arrow">←</span>

                    <div className="back-content">
                        <span className="back-label">
                            {t("profileSettings.back.label")}
                        </span>

                        <small>
                            {t("profileSettings.back.subtitle")}
                        </small>
                    </div>
                </button>

            </div>

            <div className="settings-header">
                {/* <span className="settings-kicker">CarrerUp Control Center</span> */}
                <h2>
                    {t("profileSettings.header.title")}
                </h2>
                <p>
                    {t("profileSettings.header.description")}
                </p>
            </div>
            </div>

            <div className="settings-content">
              <div className="settings-column settings-media-column">
                <MediaSection />
                <SubscriptionSection />
                <PasswordSection />
              </div>

              <div className="settings-column settings-details-column">
                <BasicInfo />
                {/* <SportProfile /> */}
                {/* <StatsSection /> */}
                <HighlightsSection />
                {/* <PreferencesSection /> */}
                {/* <PrivacySection /> */}
              </div>
            </div>

        </div>
    );
}

export default ProfileSettings
